import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M344 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v246.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L303 409c9.4 9.4 24.6 9.4 33.9 0L441 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-63 63V88zM162.2 336H160c-35.3 0-64 28.7-64 64v80c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-80c0-35.3-28.7-64-64-64h-2.2l-48 48H480c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16v-80c0-8.8 7.2-16 16-16h50.2zM464 440c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24"
    }, null, -1)
  ]))]))
}
export default { render: render }